import * as React from "react";
import { useEffect, useState } from "react";
import { HeaderSearchResults } from "../HeaderSearchResults";

export function StackedLayout({
  settings,
  query,
  productsTotal,
  articlesTotal,
  isMobile,
  articles,
  products,
  showSeeAllProductsAtBottom,
}) {
  return (
    <>
      <div>
        <div className={"header-search__stacked flex justify-between items-center"}>
          <div className="flex w-full lg:w-auto justify-between">
            <p className="text-sm lg:text-base font-medium">
              Product Results ( {productsTotal} )
            </p>

            <div className="lg:hidden w-[24px] h-[24px] border-none px-[24px] text-[20px]" x-on:click="$store.global.toggleSearch()">
              <span className="sr-only">Close</span>
              <i className="icon icon-x-thin"></i>
            </div>
          </div>

          {productsTotal > 0 &&
            <div className="hidden lg:flex gap-x-[8px]">
              <a href={`/search?q=${query}&type=product`} className="b2 button-text flex items-center gap-2">
                <span className="hover:underline">Show All Product Results</span>
              </a>
              <i className={`icon icon-ur-arrow text-[19px]`}></i>
            </div>
          }
        </div>

        {products && (
          <>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto pt-4 lg:pt-6">
              <HeaderSearchResults
                settings={settings}
                results={products}
                type={"products"}
              />
            </div>

            {isMobile && products && (
              <div className="lg:flex gap-x-[8px] flex justify-center gap-2 mt-4">
                <a
                  href={`/search?q=${query}`}
                  className="b3 button-text flex items-center"
                >
                  <span className="hover:underline">Show All Results</span>
                </a>
                <i className={`icon icon-ur-arrow text-[19px]`}></i>
              </div>
            )}
          </>
        )}
      </div>

      {articles && articlesTotal > 0 && (
        <div>
          <div className="flex w-full lg:w-auto justify-between">
            <p className="text-sm lg:text-base font-medium">
              Blog Results ( {articlesTotal} )
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto pb-4 pt-4 lg:pt-6">
            <HeaderSearchResults
              settings={settings}
              results={articles}
              type={"articles"}
            />
          </div>
        </div>
      )}
      {!isMobile && showSeeAllProductsAtBottom && products && (
          <div className="lg:flex gap-x-[8px] flex justify-center gap-2">
            <a
                href={`/search?q=${query}`}
                className="b3 button-text flex items-center"
            >
              <span className="hover:underline">Show All Results</span>
            </a>
            <i className={`icon icon-ur-arrow text-[19px]`}></i>
          </div>
      )}
    </>
  );
}
